export const pluralize = function() {
  return function(singular, plural, count) {
    var word = (Number(count) === 1) ? singular : plural;
    return word;
  };
};
